'use strict';

bbw.model.ContestList = ngtk.model.List.extend({

    _itemModel: bbw.model.Contest,

    counters: undefined,

    _initialize: function() {
        this.parent._initialize.call(this);
        this.counters = {};
    },

    load: function(args) {
        return this._load(args);
    },

    loadForSidebar: function() {
        return this.load({for_sidebar: true});
    },

    loadForAdmin: function(args) {
        return this._load(args, true);
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        this.parent._wireScope.apply(this, arguments);
        scopeInnerPtr[scopeInnerElement].counters = this.counters;
    },

    _load: function(args, forAdmin) {
        var method = forAdmin ? 'admin/contests' : 'contest';
        return this._loadFromApi('get', method, args).then(function(response) {
            this.counters.count = response.contests.count;
            this.counters.archive_count = response.contests.archive_count;
            this._setFromApiResult(response.contests.items);
        }.bind(this));
    }

});